import { render, staticRenderFns } from "./ConsultaQRCodePix.vue?vue&type=template&id=5c79577e&"
import script from "./ConsultaQRCodePix.vue?vue&type=script&lang=js&"
export * from "./ConsultaQRCodePix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports